import { useQuery } from '@tanstack/react-query';

import { RQ_PRE_MFA_TOKEN } from '@/modules/ReactQuery/cacheKeys';
import { fetchPreMfaToken } from '@/modules/mfa/api';

export function usePreMfaToken() {
  return useQuery({
    queryKey: [RQ_PRE_MFA_TOKEN],
    queryFn: fetchPreMfaToken,
  });
}
